export const contact = {
  phone: "07985780430",
  email: "lochlongjettyassociation@gmail.com",
  facebook: "",
  charity_no: "SC047932",
  "jetty-info-pdf":
    "https://llja.co.uk/assets/lljc-jetty-information-digital.pdf",
};
